import React from "react"
import CardItem from "../../components/cards/CardItem"
import { Link } from "react-router-dom"
import Slider from "react-slick"
// import { homeSliderSettings } from "../../utils/data"

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`max-md:hidden absolute left-[50%] -translate-x-[90px] -bottom-[90px] solo-button mr-8 flex justify-center items-center rounded-[50%] w-[40px] h-[40px] bg-white cursor-pointer z-10`}
      onClick={onClick}
    >
      <img src="/assets/icons/icon-arrow-long-left.svg" alt="prev" />
    </div>
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`max-md:hidden absolute left-[50%] translate-x-[50px] -bottom-[90px] solo-button mr-8 flex justify-center items-center rounded-[50%] w-[40px] h-[40px] bg-white cursor-pointer z-10`}
      onClick={onClick}
    >
      <img src="/assets/icons/icon-arrow-long-right.svg" alt="next" />
    </div>
  );
}

const homeSliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  customPaging: function (i) {
    return (
      <div className="slick-dot w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></div>
    );
  },
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 568,
      settings: {
        slidesToShow: 1
      }
    }
  ]
}

const NewlyListedSection = ({ categories, cards }) => {
  return (
    <div className="container px-5 mx-auto pb-48">
      <div className="flex items-center  justify-between flex-wrap gap-5">
        <h2 className="uppercase font-aero text-[32px] lg:text-[42px]  leading-[1.4] text-white">
          Newly Listed
        </h2>

        <div className="flex items-center gap-2 lg:mt-0 lg:gap-4">
          {/* {
            categories && categories.map(item =>
              <Link
                className="hover:bg-white uppercase w-full lg:w-fit hover:text-[#141414] justify-center text-[11px] lg:text-base flex items-center p-3 px-4 lg:p-4 lg:px-6 text-white border-style-decoration after:bottom-[-.5px] right-[-.5px]"
                key={`home-category-2-${item.id}`}
                to={`/marketplace/categories?categories=${item.id}`}
              >
                {item.name}
              </Link>
            )
          } */}

          <Link
            className="hover:bg-white uppercase w-full lg:w-fit hover:text-[#141414] justify-center text-[11px] lg:text-base flex items-center p-3 px-4 lg:p-4 lg:px-6 text-white border-style-decoration after:bottom-[-.5px] right-[-.5px]"
            to={`/marketplace/categories`}
          >
            Find Cards
          </Link>
        </div>
      </div>

      <Slider
        {...homeSliderSettings}
        className="mt-8 dots-down items-same"
      >
        {
          cards && cards.slice(0, 5).map(item =>
            <div
              key={`new-listed-${item.id}`}
              className="h-full"
            >
              <CardItem
                card={item}
              />
            </div>
          )
        }
      </Slider>

      {/* <div className="w-fit mx-auto mt-12 lg:mt-16">
        <ul className="flex items-center space-x-2">
          <li className="w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white"></li>
          <li className="w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></li>
          <li className="w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></li>
        </ul>
      </div> */}
    </div>
  )
}

export default NewlyListedSection
